import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'

/**
 * Big jumbotron at the top of the page
 */
@ngCore.Component({
  imports: [ds.input.select.single.Component],
  selector: 'atn-summit-pulse-jumbotron',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** {@link state.summit.pulse.Feature} */
  public readonly pulseFeature = ngCore.inject(state.summit.pulse.Feature)

  /** {@link state.summit.pulse.State.dateOptions} */
  public readonly dateOptions = state.summit.pulse.State.dateOptions

  public readonly currentDateSg = ngCore.computed(() =>
    new Date().toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }),
  )

  public selectedDateChanged(fromDate?: Date): void {
    if (fromDate) {
      this.pulseFeature.actions.setDate
        .from('Summit.Pulse.Jumbotron.Component.Select.Input.Changed')
        .dispatch({ fromDate })
    }
  }
}
